package com.solevo.dist.application.models

import kotlinx.serialization.Serializable

@Serializable
data class DocMetadata(
    val fileName: String? = "",
    val filePath: String? = "",
    val bucket: String? = "",
    val mimeType: String? = "application/pdf",
    val url: String? = "",
    val fileSize: Int? = 0,
    val downloadedUri: String? = null,
)